import Image from 'next/image'

import useViewport from 'libs/use-viewport'

import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'

import styles from './styles.module.scss'

import IconTelegram from './icons/social-telegram.svg'
import IconTrustPilot from './icons/social-trustpilot.svg'
import IconWhiteArrow from './icons/icon-white-arrow.svg'

export default function SocialsBlocks() {
  const { t } = useTranslation()
  const [viewport] = useViewport()

  return (
    <div className={styles.socials}>
      <a
        className={cn(styles.socials__banner, styles.socials__banner_color_green)}
        href="https://www.trustpilot.com/review/coinrabbit.io"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        <h4 className={styles.socials__heading}>{t('give_feedback_trustpilot')}</h4>
        <div className={styles.socials__footer}>
          <button className={styles.button} type="button">
            {t('review_us')}
            <img className={styles.button__arrow} src={IconWhiteArrow} alt="IconWhiteArrow" />
          </button>
          <Image
            src={IconTrustPilot}
            alt="Trustpilot"
            layout="fixed"
            width={viewport !== 'desktop' ? 66 : 84}
            height={viewport !== 'desktop' ? 20 : 26}
          />
        </div>
        <div className={cn(styles.ellipse, styles.ellipse_size_big)} />
        <div className={styles.ellipse} />
        <div className={cn(styles.ellipse, styles.ellipse_size_small)} />
      </a>

      <a
        className={cn(styles.socials__banner, styles.socials__banner_color_blue)}
        href="https://t.me/+vKoWSNIXLbZmZTQy"
        target="_blank"
        rel="noreferrer"
      >
        <h4 className={styles.socials__heading}>{t('join_telegram_community')}</h4>
        <div className={styles.socials__footer}>
          <button className={styles.button} type="button">
            {t('join_now')}
            <img className={styles.button__arrow} src={IconWhiteArrow} alt="IconWhiteArrow" />
          </button>
          <Image
            src={IconTelegram}
            alt="Telegram"
            layout="fixed"
            width={viewport !== 'desktop' ? 62 : 78}
            height={viewport !== 'desktop' ? 13 : 17}
          />
        </div>
        <div className={cn(styles.ellipse, styles.ellipse_size_big)} />
        <div className={styles.ellipse} />
        <div className={cn(styles.ellipse, styles.ellipse_size_small)} />
      </a>
    </div>
  )
}
